import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { rememberDestination } from '../../utils/postSignIn';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Loading spinner
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!currentUser) {
    // Save where they were headed. sessionStorage (via rememberDestination),
    // NOT only router state: mobile sign-in is a full-page redirect and
    // router state does not survive it — this was why every lifecycle-email
    // deep link landed on /universities instead of the promised feature.
    rememberDestination(location.pathname + location.search);
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
